module.exports = __webpack_public_path__ + "img/bonus2.547f04c5.png";